// Por último, importamos tudo e exportamos um único objeto
import ptBrTranslations from './pt-br';
import enUsTranslations from './en-us';

// Lista das abreviações corretas: https://support.mozilla.org/pt-BR/kb/abreviacao-de-localizacao
export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations
};
